import { Routes } from "@angular/router";
import { CompanyGuard } from "./core/guards/company.guard";
import { RoleGuard } from "./core/guards/role.guard";
import { ErrorPageComponent } from "./features/error-page/error-page.component";
import { ElectronAuthGuard } from "./core/guards/electron-auth.guard";
import { IsElectronAppGuard } from "./core/guards/is-electron-app.guard";

export const ELECTRON_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    canActivate: [ElectronAuthGuard],
    loadComponent: () => import('./features/homepage/homepage.component').then((m) => m.HomepageComponent)
  },
  {
    path: 'deflaker',
    canActivate: [ElectronAuthGuard, RoleGuard, CompanyGuard],
    loadChildren: () => import('./features/deflaker/deflaker.routes').then((m) => m.DEFLAKER_ROUTES),
    data: { roles: ['DeflakerBasic'] }
  },
  {
    path: 'hydrascreen',
    canActivate: [ElectronAuthGuard, RoleGuard, CompanyGuard],
    loadChildren: () => import('./features/hydra-screen/hydra-screen.routes').then((m) => m.HYDRA_SCREEN_ROUTES),
    data: { roles: ['HydraScreenBasic'] }
  },
  {
    path: 'micrascreen',
    canActivate: [ElectronAuthGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/micra-screen/micra-screen.routes').then((m) => m.MICRA_SCREEN_ROUTES),
    data: { roles: ['MicraScreenBasic'] }
  },
  {
    path: 'fsupulper',
    canActivate: [ElectronAuthGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/fsu-pulper/fsu-pulper.routes').then((m) => m.FSU_PULPER_ROUTES),
    data: { roles: ['FsuPulperBasic'] }
  },
  {
    path: 'hcrefiner',
    canActivate: [ElectronAuthGuard, CompanyGuard, RoleGuard],
    loadChildren: () => import('./features/hc-refiner/hc-refiner.routes').then((m) => m.HC_REFINER_ROUTES),
    data: { roles: ['HcRefinerBasic'] }
  },
  {
    path: 'desktop-sync',
    canActivate: [IsElectronAppGuard],
    loadChildren: () => import('./features/desktop-sync/desktop-sync.routes').then((m) => m.DESKTOP_SYNC_ROUTES)
  },
  {
    path: 'no-registered',
    canActivate: [ElectronAuthGuard],
    component: ErrorPageComponent,
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 401,
      title: 'User is not registered in SizingTools application',
      description: 'Please contact your application administrator',
      url: '',
      label: '',
    },
  },
  {
    path: 'no-permission',
    canActivate: [ElectronAuthGuard],
    component: ErrorPageComponent,
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 403,
      title: 'Permission denied.',
      description: 'Please contact your application administrator',
      url: '',
      label: '',
    },
  },
  {
    path: '404',
    component: ErrorPageComponent,
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 404,
      title: 'Page not found.',
      description: '',
      url: '/',
      label: 'Go Home',
    },
  },
  {
    path: '**',
    redirectTo: 'home'
  },
];